module.exports = __webpack_public_path__ + "img/Accountant.png";